import { saveAs } from 'file-saver'
import { isString } from 'lodash'

import { warning } from './warning'

/**
 * 下载 url 文件
 */
export const downloadUrl = (url: string | URL, filename?: string) => {
  try {
    saveAs(isString(url) ? url : url.toString(), filename)
  } catch (e) {
    warning(false, 'utils:file', e)
  }
}

/**
 * 把内容另存为文件
 */
export const downloadContent = (content: Blob | string, filename?: string) => {
  saveAs(isString(content) ? new Blob([content]) : content, filename)
}
